/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { BasePaymentMethod } from "Shared/Models";

import Customer from "./Customer";

type PaymentMethod = BasePaymentMethod<Customer>;

export default PaymentMethod;
